'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { ampli as ampliDigital } from '@src/ampli-web-digital';
import { getBadgeCelebrationEventProps } from '@src/utils/badge-analytics.util';
interface BadgeCelebrationAnalyticsProps {
  badge: GamificationApi.Badge | null;
}
export function BadgeCelebrationAnalytics(t0) {
  const $ = _c(3);
  const {
    badge
  } = t0;
  let t1;
  let t2;
  if ($[0] !== badge) {
    t1 = () => {
      if (!ampliDigital.isLoaded || !badge) {
        return;
      }
      ampliDigital.viewBadgeCelebration(getBadgeCelebrationEventProps(badge));
    };
    t2 = [badge];
    $[0] = badge;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}